export default __webpack_public_path__ + "static/media/smolder.e62af54d.jpg";